import { useState, useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { describeSetupIntent } from '../../../helpers/stripeStatus';

type SaveDataStatusProps = {
  clientSecret: string;
};

const SaveDataStatus = ({ clientSecret }: SaveDataStatusProps) => {
  const stripe = useStripe();
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!stripe || !clientSecret) {
      return;
    }

    stripe
      .retrieveSetupIntent(clientSecret)
      .then(({ setupIntent, error }: any) => {
        if (error) {
          setMessage(error.message || describeSetupIntent(undefined).message);
          return;
        }
        setMessage(describeSetupIntent(setupIntent?.status).message);
      })
      .catch(() => {
        setMessage(describeSetupIntent(undefined).message);
      });
  }, [stripe, clientSecret]);

  return <span>{message}</span>;
};

export default SaveDataStatus;
